import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import styles from './styles';

class Search extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    searchString: PropTypes.string.isRequired,
    setSearchString: PropTypes.func.isRequired,
  }

  handleChange = (event) => {
    this.props.setSearchString(event.target.value);
  }

  clear = () => {
    this.props.setSearchString('');
  }

  render() {
    const { classes, searchString } = this.props;
    return (
      <div className={classes.search}>
        <input
          className={classes.input}
          placeholder="Search all pricing info"
          value={searchString}
          onChange={this.handleChange}
        />
        <div className={classes.iconContainer}>
          <span className={`${classes.searchIcon} lui-icon  lui-icon--search`} aria-hidden="true" />
        </div>
        <span
          className={`${classes.closeIcon} lui-icon lui-icon--close`}
          aria-hidden="true"
          style={{ display: searchString !== '' ? 'inline-block' : 'none' }}
          onClick={this.clear}
        />
      </div>
    );
  }
}

export default injectSheet(styles)(Search);
